import { gql, useQuery } from '@apollo/client';
import { CampaignByIdQueryDocument, CampaignByIdQuery } from 'src/common/__generated__/api';
import CampaignRecommendations = CampaignByIdQuery.CampaignRecommendations;

const campaignByIdQuery = gql`
  ${CampaignByIdQueryDocument}
`;

type FetchOptions = {
  variables: CampaignByIdQuery.Variables;
  updateQuery: (
    previousQueryResult: any,
    options: {
      fetchMoreResult?: any;
      variables?: CampaignByIdQuery.Variables;
    }
  ) => any;
};

type FetchMore = (options: FetchOptions) => void;

export type CampaignByIdResponse = { campaignRecommendations: CampaignRecommendations };

export function useCampaignById(variables: CampaignByIdQuery.Variables) {
  const response = useQuery<CampaignByIdResponse>(campaignByIdQuery, {
    variables,
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  return { ...response, fetchMore: buildFetchMore(response.fetchMore, variables) };
}

export const buildFetchMore =
  (fetchMore: FetchMore, currentVariables: any): FetchMore =>
  ({ variables: newVariables }): void => {
    /* istanbul ignore next */
    fetchMore({
      updateQuery: (prev, { fetchMoreResult }) => {
        const prevCampaigns = prev.campaignRecommendations?.campaigns[0];
        const prevOffers = prevCampaigns?.offers;
        const moreCampaigns = fetchMoreResult?.campaignRecommendations?.campaigns[0];
        const moreOffers = moreCampaigns?.offers;

        if (!fetchMoreResult || !prevOffers || !moreOffers) {
          return prev;
        }

        return {
          ...prev,
          campaignRecommendations: {
            ...prev.campaignRecommendations,
            campaigns: [
              {
                ...prevCampaigns,
                ...moreCampaigns,
                offers: [...prevOffers, ...moreOffers],
              },
            ],
          },
        };
      },
      variables: {
        ...currentVariables,
        ...newVariables,
      },
    });
  };

export default useCampaignById;
